import { MessageCircle } from "lucide-react";
import { DEFAULT_WA } from "../../lib/api";

export default function WhatsAppFloat() {
  return (
    <a
      data-testid="whatsapp-float"
      href={DEFAULT_WA}
      target="_blank"
      rel="noreferrer"
      aria-label="Fale conosco no WhatsApp"
      className="pulse-ring fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-crimson hover:bg-crimson-bright text-paper flex items-center justify-center shadow-2xl transition-transform duration-300 hover:scale-110"
    >
      <MessageCircle size={24} />
    </a>
  );
}
